export default "__VITE_PUBLIC_ASSET__cd39b918__"